module.exports = __webpack_public_path__ + "static/media/sidebar-2.7a4ce7cc.jpg";